var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bonus-search',{on:{"doSearch":_vm.doSearch}}),_c('bonus-list',{ref:"refBonusList"}),_c('Tips',{attrs:{"data":_vm.tipList,"title":"提示"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }